import { render, staticRenderFns } from "./deliveryNote.vue?vue&type=template&id=0515da50&scoped=true"
import script from "./deliveryNote.vue?vue&type=script&lang=js"
export * from "./deliveryNote.vue?vue&type=script&lang=js"
import style0 from "./deliveryNote.vue?vue&type=style&index=0&id=0515da50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0515da50",
  null
  
)

export default component.exports